const options = Object.freeze({
  auto: 'auto',
  light: 'light',
  dark: 'dark',
});

export { options }; // eslint-disable-line import/prefer-default-export
